<template>
  <div class="wrapper">
    <div class="main visual-2 nodoc">
      <Header :backRoute="'/'" />
      <div class="vis4-inr1 nodoc-inr">
        <h1>There is no doctor<br />available during this time.</h1>
        <img src="@/assets/img/opt-2-img.png" />
        <br />
        <router-link to="#">
          <button class="nodoc-btn">Reschedule</button>
        </router-link>
      </div>
      <div class="hlp-btn">
        <router-link to="/customer-support">
          <i class="fa-solid fa-circle-info"></i> Help
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header.vue";
export default {
  components: {
    Header,
  },
  name: "NoDoctor",
};
</script>
